// frontend/src/pages/Proposals/ProposalList.jsx
// Admin: list all vendor proposals, filter by status
import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";
import { getProposals } from "../../api/proposal.api.js";
import { PageHeader, Spinner, EmptyState, StatusBadge, formatDate } from "../../components/ui";

const FILTERS = [
  { value: "", label: "Semua" },
  { value: "PENDING", label: "Menunggu" },
  { value: "ACCEPTED", label: "Diterima" },
  { value: "REJECTED", label: "Ditolak" },
];

export default function ProposalList() {
  const [statusFilter, setStatusFilter] = useState("");

  const { data: proposals, isLoading } = useQuery({
    queryKey: ["proposals", statusFilter],
    queryFn: () => getProposals(statusFilter ? { status: statusFilter } : {}),
  });

  return (
    <div>
      <PageHeader
        title="Pengajuan Vendor"
        subtitle="Proposal perjanjian yang diajukan oleh vendor."
      />

      {/* Status filter */}
      <div className="flex gap-2 mb-5 flex-wrap">
        {FILTERS.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => setStatusFilter(value)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
              statusFilter === value
                ? "bg-brand-600 text-white border-brand-600"
                : "border-gray-200 text-gray-600 hover:border-gray-400"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <Spinner />
      ) : !proposals?.length ? (
        <EmptyState
          title="Tidak ada pengajuan"
          description={
            statusFilter
              ? `Tidak ada pengajuan berstatus "${FILTERS.find((f) => f.value === statusFilter)?.label}".`
              : "Belum ada pengajuan dari vendor."
          }
        />
      ) : (
        <div className="card divide-y divide-gray-100">
          {proposals.map((p) => (
            <Link
              key={p.id}
              to={`/proposals/${p.id}`}
              className="flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900 truncate">{p.title}</p>
                <p className="text-sm text-gray-500 mt-0.5">
                  {p.vendor?.companyName}
                  {p.vendor?.picName && ` · ${p.vendor.picName}`}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">{formatDate(p.createdAt)}</p>
              </div>
              <StatusBadge status={p.status} />
              <ChevronRight size={16} className="text-gray-300 shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
